
export default {
	name: 'loginanim'
};
